<div class="event-wrapper">
  <div class="event-container item">
    <evrideo-calendar-expandable-red-line-indicator
      [redLineVisible]="properties.redLineVisible"
    ></evrideo-calendar-expandable-red-line-indicator>
    <div
      class="visibility-icon"
      (click)="toggleSecEvent(show, autopilotData.properties.id)"
      [inlineSVG]="
        autopilotData.properties.enabled
          ? '../../assets/icons/eye-icon.svg'
          : '../../assets/icons/eye-disabled.svg'
      "
    ></div>
    <evrideo-calendar-expandable-progress-bar
      [eventData]="properties"
      class="a"
    ></evrideo-calendar-expandable-progress-bar>
    <div class="item-title-container z">
      <div
        class="event-icon"
        inlineSVG="../../assets/icons/autopilot-icon.svg"
      ></div>
      <span class="item-title-text">Autopilot</span>
    </div>
    <div class="item-name z">
      {{ properties.ruleType === 0 ? "GFX rule" : "Media rule" }}:
      {{ properties.name }}
    </div>
    <div class="start-time-container z">
      <evrideo-calendar-expandable-editable-time
        [time]="formatTime(properties.startTime)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="end-time-container z">
      <evrideo-calendar-expandable-editable-time
        [time]="formatTime(properties.endTime)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="duration-time-container z">
      <evrideo-calendar-expandable-editable-time
        [time]="formatDuration(properties.duration)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="offset-time-container z">
      <evrideo-calendar-expandable-editable-time
        [time]="formatDuration(properties.offset)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="right-items z">
      <a
        class="rule-item z"
        href="/autopilot/edit/{{ autopilotData.properties.ruleId }}"
        >Rule</a
      >
      <a
        *ngIf="autopilotData.properties.ruleType === 0"
        class="instance-item z"
        href="/scheduler/graphics/edit/{{
          autopilotData.properties.relatedMediaId
        }}"
        >Instance</a
      >
      <a
        *ngIf="autopilotData.properties.ruleType === 1"
        class="instance-item z"
        href="/mam/editMedia/{{ autopilotData.properties.relatedMediaId }}"
        >Edit Media</a
      >
      <!--            <div class="" inlineSVG="../../assets/icons/trash-disabled.svg"></div>-->
    </div>
  </div>
</div>
